import { isCarouselSlidesResponse } from "@dashboardApi/apis/engagementCanvasCarouselSlides/validators";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { CarouselSlidesResponse } from "./types";

export const getEngagementCanvasCarouselSlides = reactQueryFetcherAdapter(
  cacheKey,
  async (signal, workflowId, query, limit, templateId): Promise<CarouselSlidesResponse> => {
    return fetch(
      `/engagement/canvas/carousel_slides_for_canvas`,
      "GET",
      {
        query,
        selected_workflow_id: workflowId,
        limit,
        template_id: templateId,
      },
      { signal }
    );
  },
  isCarouselSlidesResponse
);
